import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Paper, Typography, Grid, Divider, Box } from '@mui/material';

function OrderSummary({ totalQuantity, totalProductCount }) {
	const { t } = useTranslation();

	return (
		<Paper
			elevation={4}
			sx={{
				p: 2,
				mt: 3,
				mx: 0.5,
				borderRadius: 2,
				minHeight: 160,
			}}
		>
			{/* Title */}
			<Typography variant="heading5" sx={{ mb: 2 }}>
				{t('new_orders:order_summary:title')}
			</Typography>

			{/* Summary rows */}
			<Divider sx={{ mt: 2 }} />

			<Box sx={{ py: 1 }}>
				<Grid container>
					<Grid item xs={8}>
						<Typography>
							{t('new_orders:order_summary:total_quantity')}
						</Typography>
					</Grid>
					<Grid item xs={4}>
						<Typography align="right">{totalQuantity}</Typography>
					</Grid>
				</Grid>
			</Box>

			<Divider />

			<Box sx={{ py: 1 }}>
				<Grid container>
					<Grid item xs={8}>
						<Typography>
							{t('new_orders:order_summary:total_product_count')}
						</Typography>
					</Grid>
					<Grid item xs={4}>
						<Typography align="right">{totalProductCount}</Typography>
					</Grid>
				</Grid>
			</Box>
		</Paper>
	);
}

OrderSummary.propTypes = {
	totalQuantity: PropTypes.number.isRequired,
	totalProductCount: PropTypes.number.isRequired,
};

export default OrderSummary;
